import React from 'react';
import { renderBanner } from './shared/renderers';

/**
 * BannerBlock — rendu PARTAGÉ avec l'éditeur intranet (shared/renderers).
 * L'app se contente d'appeler le rendu commun : couleurs, icône et CTA sont
 * donc identiques à ce que l'éditrice voit dans l'aperçu Puck.
 */
export default function BannerBlock({ props = {}, theme }) {
  return renderBanner(props, theme);
}
